/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Retrospective_Week_InvalidInputs */

const en_us2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That week does not exist: ${i?.week}. Pick another one.`)
};

const pt_br2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essa semana não existe: ${i?.week}. Escolha outra.`)
};

const es_419_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esa semana no existe: ${i?.week}. Elige otra.`)
};

const pt_pt2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Essa semana não existe: ${i?.week}. Escolhe outra.`)
};

const fr_fr2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette semaine n'existe pas : ${i?.week}. Choisis-en une autre.`)
};

const de_de2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diese Woche gibt es nicht: ${i?.week}. Wähle eine andere.`)
};

const it_it2_retrospective_week_invalid = /** @type {(inputs: Retrospective_Week_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questa settimana non esiste: ${i?.week}. Scegline un'altra.`)
};

/**
* | output |
* | --- |
* | "That week does not exist: {week}. Pick another one." |
*
* @param {Retrospective_Week_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const retrospective_week_invalid = /** @type {((inputs: Retrospective_Week_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retrospective_Week_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_retrospective_week_invalid(inputs)
	if (locale === "es-419") return es_419_retrospective_week_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_retrospective_week_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_retrospective_week_invalid(inputs)
	if (locale === "de-DE") return de_de2_retrospective_week_invalid(inputs)
	if (locale === "it-IT") return it_it2_retrospective_week_invalid(inputs)
	return en_us2_retrospective_week_invalid(inputs)
});
export { retrospective_week_invalid as "retrospective.week_invalid" }